<template>
  <!-- 背景模糊层 -->
  <div
    class="absolute inset-0 glass-frosted"
    :style="{
      maskImage: `url(${frameUrl})`,
      WebkitMaskImage: `url(${frameUrl})`,
      maskSize: '100% 100%',
      WebkitMaskSize: '100% 100%',
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
    }"
  />

  <!-- 背景图片 -->
  <img
    :key="frameUrl"
    :src="frameUrl"
    class="block w-auto h-auto max-w-none shrink-0 opacity-30"
    :style="frameSize && { width: `${frameSize.width}px`, height: `${frameSize.height}px` }"
    @load="handleFrameLoad"
    @error="emit('ready', false)"
  />

  <!-- 键盘特殊部件 -->
  <!-- <div
    v-if="widgetUrl"
    class="absolute inset-0"
    :style="{
      maskImage: `url(${widgetUrl})`,
      WebkitMaskImage: `url(${widgetUrl})`,
      maskSize: '100% 100%',
      WebkitMaskSize: '100% 100%',
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
      background: 'linear-gradient(180deg, #FFFFFF 0%, #BEFF57 100%)',
    }"
  /> -->
</template>

<script lang="ts">
  const loadedFrameSizes = new Map<string, { width: number; height: number }>()
</script>

<script setup lang="ts">
  import { computed, shallowRef, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useThemeStore } from '@/stores'
  import { getImageUrl } from '@/utils/assets'

  const props = defineProps<{
    assetsDir: string
  }>()

  const emit = defineEmits<{
    (e: 'ready', ready: boolean): void
  }>()

  const themeStore = useThemeStore()
  const { isDark } = storeToRefs(themeStore)

  const frameUrl = computed(() => {
    if (isDark.value) {
      return getImageUrl(`${props.assetsDir}/frame-dark.png`)
    } else {
      return getImageUrl(`${props.assetsDir}/frame-light.png`)
    }
  })
  // const widgetUrl = computed(() => getImageUrl(`${props.assetsDir}/widget.png`))

  const frameSize = shallowRef<{ width: number; height: number }>()

  const handleFrameLoad = (event: Event) => {
    const image = event.target as HTMLImageElement
    if (image.getAttribute('src') !== frameUrl.value) return
    const size = { width: image.naturalWidth, height: image.naturalHeight }
    loadedFrameSizes.set(frameUrl.value, size)
    frameSize.value = size
    emit('ready', true)
  }

  watch(
    frameUrl,
    (url) => {
      frameSize.value = loadedFrameSizes.get(url)
      emit('ready', Boolean(frameSize.value))
    },
    { immediate: true, flush: 'sync' },
  )
</script>

<style scoped></style>
